import React from 'react'
import weedingevent from "../images/Luxury weeding event book.jpg";
import bannermainbuild from "../images/BANNER MAIN BUILD PHOTO.jpg";
import vojanrestaurant from "../images/Vojan Restaurant.jpg";
import diwali from "../images/DIWALI Web background v.3.jpg";


import {Link} from "react-router-dom";
function Slider() {
  return (
    <div>
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>

  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={bannermainbuild} className="d-block w-100" alt="best hotel in Berhampore"/>
    </div>
    
     <div className="carousel-item">
      <Link to="/Reception-book">
      <img src={weedingevent} className="d-block w-100" alt="vilas club resort"/>
      </Link>
    </div>
    <div className="carousel-item">
      <img src={vojanrestaurant} className="d-block w-100" alt="vojanrestaurant"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider